import { ref } from "vue";
import { registerNativeHandler } from "@/utils/reactNativeBus";

export function useNativeCheckPushPermission() {
  const derigesterHandler = ref(null);

  function checkNativePushPermission() {
    let pushAccessGranted = false;
    let canRequestPushAccess = false;
    return new Promise((resolve) => {
      derigesterHandler.value = registerNativeHandler(
        "onUserPushStatus",
        (payload) => {
          derigesterHandler.value();

          const { status, data } = payload;

          if (status === "success") {
            pushAccessGranted = data?.pushAccessGranted ?? false;
            canRequestPushAccess = data?.canRequestPushAccess ?? false;
          }

          resolve({
            pushAccessGranted,
            canRequestPushAccess,
          });
        }
      );
      window.SababuuNativeBridge.getUserPushStatus();
    });
  }

  return {
    checkNativePushPermission,
  };
}
